<template>
  <el-form
    :model="currency"
    ref="currencyForm"
    :rules="rules"
    style="padding: 15px"
    class="bg-white"
    label-position="top"
    v-loading="isLoading"
  >
    <h4 class="form-title">Currency Information</h4>

    <el-row :gutter="15">
      <el-col :sm="12">
        <el-form-item label="Name" prop="name">
          <el-input v-model="currency.name"></el-input>
        </el-form-item>
      </el-col>
      <el-col :sm="12">
        <el-form-item label="Sign" prop="sign">
          <el-input v-model="currency.sign"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-form-item label="Equivalent amount in AED" prop="rate">
      <!-- <el-input type="number" v-model.number="currency.rate"></el-input> -->
      <el-input-number
        v-model="currency.rate"
        :controls="false"
        :precision="4"
        class="w-100"
      ></el-input-number>
    </el-form-item>
    <el-button type="primary" @click="submit" size="small">Save</el-button>
    <el-button size="small" @click="cancel">Cancel</el-button>
  </el-form>
</template>

<script>
import Currency from "@/models/Currency";
export default {
  name: "CurrencyInfo",
  data() {
    return {
      currency: new Currency(),
      isLoading: false,
      rules: Currency.rules()
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      Currency.fetch(this.$route.params.id).then(resp => {
        this.currency = resp;
      });
    }
  },
  methods: {
    cancel() {
      this.$router.push({ name: "currency" });
    },
    submit() {
      this.$confirm(
        "Are you sure you want to save this currency information?",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No"
        }
      )
        .then(() => {
          this.$refs["currencyForm"].validate(valid => {
            if (!valid) return false;

            if (!this.currency.id) {
              this.isLoading = true;
              Currency.create(this.currency).then(resp => {
                this.isLoading = false;
                if (resp) {
                  this.$notify({
                    type: "success",
                    message: "Currency information saved successfully.",
                    position: "bottom-right"
                  });
                  this.$router.push({ name: "currency" });
                }
              });
            } else {
              this.isLoading = true;
              Currency.put(this.currency).then(resp => {
                this.isLoading = false;
                if (resp) {
                  this.$notify({
                    type: "success",
                    message: "Currency information saved successfully.",
                    position: "bottom-right"
                  });
                  this.$router.push({ name: "currency" });
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="css" scoped></style>
